// custom hover intent
document.querySelectorAll('.list-menu--megamenu').forEach((menuItem) => {
  const megaMenu = menuItem.querySelector('.mega-menu');
  let hoverTimer;

  menuItem.addEventListener('mouseenter', () => {
    hoverTimer = setTimeout(() => {
      megaMenu.classList.add('visible');
    }, 100); // delay for hover intent
  });

  menuItem.addEventListener('mouseleave', () => {
    clearTimeout(hoverTimer);
    megaMenu.classList.remove('visible');
  });
});

// load menu images
const observer = new MutationObserver((mutationsList) => {
  mutationsList.forEach((mutation) => {
    if (
      mutation.type === 'attributes' &&
      mutation.attributeName === 'class' &&
      mutation.target.classList.contains('visible')
    ) {
      const images = mutation.target.querySelectorAll('img[data-src]');
      images.forEach((img) => {
        img.src = img.dataset.src;
        img.removeAttribute('data-src');
      });
    }
  });
});

document.querySelectorAll('.mega-menu').forEach((menu) => {
  observer.observe(menu, { attributes: true });
});